/**
 * Main App Component
 * Sets up routing and providers
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './store/AuthContext';
import { AdminProvider } from './store/AdminContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Layout from './components/layout/Layout';
import PageRouter from './components/routing/PageRouter';
import LoginPage from './pages/LoginPage';
import FirstLoginSetupPage from './pages/FirstLoginSetupPage';
import PasswordResetPage from './pages/PasswordResetPage';
import SuspendedModal from './components/modals/SuspendedModal';
import './App.css';

const SuspendedCheck: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { admin } = useAuth();
  const isSuspended = admin !== null && admin.active === false;

  return (
    <>
      {children}
      <SuspendedModal isOpen={isSuspended} />
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <AdminProvider>
          <div className="App">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/first-login" element={<FirstLoginSetupPage />} />
              <Route path="/reset-password" element={<PasswordResetPage />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <SuspendedCheck>
                      <Layout>
                        <PageRouter />
                      </Layout>
                    </SuspendedCheck>
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </AdminProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;

